export const TypeModule = ['BilanPositionnement', 'Externe', 'BilanEvaluation'] as const
export type TypeModule = typeof TypeModule[number]

export const TypeModuleLabel: Record<TypeModule, string> = {
  BilanPositionnement: "Bilan de positionnement",
  Externe: "Externe",
  BilanEvaluation: "Bilan d'évaluation"
}

